import { defineStore } from "pinia";
import { ref } from "vue";
import { useApi } from "@/features/Api/useApi";

export const useTeam = defineStore(
  "useTeam",
  () => {
    const api = useApi();

    const teams = ref([]);
    const loading = ref(false);
    const loadTeams = async () => {
      if (loading.value) {
        return;
      }
      loading.value = true;
      await api
        .get("/teams")
        .then(({ data }) => {
          teams.value = data;
        })
        .finally(() => (loading.value = false));
    };
    return {
      loadTeams,
      teams,
    };
  },
  {
    persist: [
      {
        paths: ["teams"],
        storage: sessionStorage,
      },
    ],
  }
);
